import React, { memo } from 'react';

import { ExternalFulfillmentConfiguration } from './configs/external-fulfillment';
import { ShipmentConfiguration } from './configs/shipment';
import { HeaderActions } from './header-actions';
import messages from './messages';
import { useContainsDemoOrder } from '../../../../../demos/hooks/use-contains-demo-order';
import { EXTERNAL_FULFILLMENTS, STANDARD } from '../../../../../enums/csw-types';
import { useFulfillmentPlannerContext } from '../../../../../fulfillment-planner/context';
import { useFulfillmentPlanIdContext } from '../../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import ConfigureShipmentForm from '../../../configure-shipment/form/configure-shipment-form';
import ConfigureShipmentSection from '../../../configure-shipment/section/configure-shipment-section';

const CSW_CONFIGURATIONS = {
  [STANDARD]: ShipmentConfiguration,
  [EXTERNAL_FULFILLMENTS]: ExternalFulfillmentConfiguration,
};

export const ConfigureShipment = memo(() => {
  const fulfillmentPlanId = useFulfillmentPlanIdContext();
  const { cswTypeId } = useFulfillmentPlannerContext();
  const isDemoOrder = useContainsDemoOrder([fulfillmentPlanId]);
  const ConfigurationComponent = CSW_CONFIGURATIONS[cswTypeId] || ShipmentConfiguration;
  return (
    <ConfigureShipmentSection
      ariaLabelMessageDescriptor={messages.sectionAriaLabel}
      headerActions={<HeaderActions fulfillmentPlanId={fulfillmentPlanId} />}
      isDemoOrder={isDemoOrder}
      sectionTitleMessageDescriptor={messages.sectionTitle}
    >
      <ConfigureShipmentForm>
        <ConfigurationComponent fulfillmentPlanId={fulfillmentPlanId} />
      </ConfigureShipmentForm>
    </ConfigureShipmentSection>
  );
});
